function uintToMimeType(uint: any): string {
    // Bytes
    const bytes: any[] = [];

    // Foreach Uint
    for (const item of uint) {
        bytes.push(item.toString(16));
    }

    // Hex
    const hex = bytes.join('');

    // Hex Signature
    const sig = hex.slice(0, 8);

    // Switch
    switch (sig) {
        case 'ffd8ffdb':
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
            return 'image/jpeg';
        case '89504e47':
            return 'image/png';
        case '47494638':
            return 'image/gif';
        case '49492a08':
        case '4d4d02a0':
            return 'image/tiff';
        case '25504446':
            return 'application/pdf';
        case '504b0304':
            return 'application/zip';
        default:
            return '';
    }
}

// ----------------------------------------------------------------------------

export default uintToMimeType;
